<div class="py-24 sm:py-32">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="mx-auto max-w-2xl lg:text-center" @fadeIn>
      <h2 class="text-base font-semibold leading-7 text-indigo-600">
        {{ "home.features-section.title" | translate }}
      </h2>
      <p
        class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
      >
        {{ "home.features-section.subtitle" | translate }}
      </p>
      <p class="mt-6 text-lg leading-8 text-gray-600">
        {{ "home.features-section.description" | translate }}
      </p>
    </div>
    <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
      <dl
        class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3"
        @staggerFade
      >
        <ng-container
          *ngFor="let feature of features"
        >
          <div class="flex flex-col">
            <dt
              class="flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900 group transition-all duration-300 hover:text-indigo-600"
            >
              <svg
                class="h-5 w-5 flex-none text-indigo-600 transition-transform duration-300 group-hover:scale-110"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  [attr.d]="feature.icon"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ feature.title }}
            </dt>
            <dd
              class="mt-4 flex flex-auto flex-col text-base leading-7 text-gray-600"
            >
              <p class="flex-auto">{{ feature.description }}</p>
            </dd>
          </div>
        </ng-container>
      </dl>
      <!-- See More Button -->
      <div class="mt-16 flex justify-center">
        <a
          [routerLink]="['/features']"
          class="group inline-flex items-center text-base font-semibold text-indigo-600 hover:text-indigo-500 transition-all duration-300 hover:scale-105"
        >
          {{ "home.features-section.see_more" | translate }}
          <span
            [ngClass]="{'ml-2': translate.currentLang === 'en', 'mr-2': translate.currentLang === 'ar', 'transform rotate-180': translate.currentLang === 'ar'}"
            class="transform transition-transform duration-300"
            [class.group-hover:translate-x-2]="translate.currentLang === 'en'"
            [class.group-hover:-translate-x-2]="translate.currentLang === 'ar'"
            >→</span
          >
        </a>
      </div>
    </div>
  </div>
</div>
